import { useTranslation } from 'react-i18next';

import { Button } from '@myphx-engineering/phx-design-system';

import { getAbsoluteRoute } from '../../../util/get-absolute-route';

export const KeepCurrentPrescriptionButton = ({
    prescriberOrderId,
}: {
    prescriberOrderId: string;
}) => {
    const { t } = useTranslation();

    return (
        <Button
            link
            to={getAbsoluteRoute('order.prescriberOrderId.details', {
                prescriberOrderId: prescriberOrderId!,
            })}
            variant="outline"
        >
            {t('verifyPrescription.keepPrescription')}
        </Button>
    );
};
